import { normalizeDigits } from './statement';

/**
 * بحث القوائم فى المتصفح. القوائم تصل كاملة من الخادم، فالتصفية هنا فورية بلا طلب جديد.
 * المطابقة تتسامح فيما يكتبه الناس بأشكال مختلفة: الهمزات، والتاء المربوطة، والألف
 * المقصورة، والتشكيل، والأرقام الهندية — «احمد» تجد «أحمد»، و«١٢» تجد «12».
 */

const DIACRITICS = /[ً-ْٰـ]/g;

export function normalizeSearch(value: string): string {
  return normalizeDigits(value)
    .replace(DIACRITICS, '')
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ة/g, 'ه')
    .replace(/ى/g, 'ي')
    .replace(/ؤ/g, 'و')
    .replace(/ئ/g, 'ي')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** كل كلمة فى البحث لازم تظهر فى أى حقل — «محمد القاهرة» تجد العميل بالاسم والعنوان معًا. */
export function matchesSearch(
  query: string,
  fields: readonly (string | number | null | undefined)[],
): boolean {
  const words = normalizeSearch(query).split(' ').filter(Boolean);
  if (words.length === 0) return true;
  const haystack = normalizeSearch(
    fields
      .filter((field) => field !== null && field !== undefined)
      .map(String)
      .join(' '),
  );
  return words.every((word) => haystack.includes(word));
}

/** التاريخ `YYYY-MM-DD` بين حدّين اختياريين — المقارنة النصية صحيحة لهذا الشكل. */
export function inDateRange(date: string, from: string, to: string): boolean {
  return (!from || date >= from) && (!to || date <= to);
}
